export { default } from './Renegociacao25Vantagens';
